import {
    getCustomer,
} from "./apiroutes";
  
import customAxios from "./interceptor";
  
  
export const getBetsData = ({ page, limit, searchQuery }) => {
    return async (dispatch) => {
      try {
        const response = await customAxios.get("/", {
          params: { page, limit, search: searchQuery }
        });
        return { status: true, data: response.data };
      } catch (err) {
        return { status: false, message: err.message };
      }
    };
  };
  
  export const getBetDetails = (betId) => {
    return async (dispatch) => {
      try {
        const response = await customAxios.get(`/bets/${betId}`);
        return { status: true, data: response.data };
      } catch (err) {
        return { status: false, message: err.message };
      }
    };
  };
  
  export const deleteBet = (betId) => {
    return async (dispatch) => {
      try {
        const response = await customAxios.delete(`/admin/delete-bet/${betId}`);
        return { status: true, data: response.data };
      } catch (err) {
        return { status: false, message: err.message };
      }
    };
  };